// Whole Component Tejashwini
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import UserForm from "./userForm";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SearchBox from "./searchbox";
import TableSortLabel from "@mui/material/TableSortLabel";
import { alpha } from "@mui/material/styles";
import DialogTitle from '@mui/material/DialogTitle';
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Checkbox from "@mui/material/Checkbox";
import {  InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'
import CategoryIcon from '../images/category-01.png'; 
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

const ModalStyle = {
  position: "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

export default function Category() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [dialogOpen, setDialogOpen] = useState(false); 
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("category_id");

  const [isAddCategoryModal, setisAddCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState(0);
  const [categoryName, setCategoryName] = useState("");
  const [categoryLabel, setCategoryLabel] = useState("Enter Category");
  const [categoryNameError, setCategoryNameError] = useState(false);
  const [category, setcategory] = useState([{}]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isCategoryConfirmationOpen, setIsCategoryConfirmationOpen] = useState(false);
  const [categoryDeleteMsg, setCategoryDeleteMsg] = useState("");
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const openAddCategoryModal = () => {
    setCategoryId(null);  
    setCategoryName("");  
    setCategoryLabel("Enter Category"); 
    setCategoryNameError(false); 
    setisAddCategoryModal(true); 
  };
  
  const openEditCategoryModal = (categoryId) => {
    console.log("Editing category:", categoryId);
    setCategoryId(categoryId);
  
    const selectedCategory = paginatedRows.find(
      (row) => row.category_id === categoryId
    );
  
    if (selectedCategory) {
      setCategoryName(selectedCategory.category_name); 
    } else {
      setCategoryName(''); 
    }
  
    setisAddCategoryModal(true); 
  };
  
  const reset =()=> {
    setCategoryId("");
    setCategoryName("");
    setCategoryLabel("Enter Category");
    setCategoryNameError(false);
  }

  useEffect(()=>{
    setOrder('desc');
    setOrderBy('category_id')
  },[])

  const getCategory = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/category/getCategory",
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      );
  
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
  
      const data = await response.json();
      console.log("Fetched Categories:", data); // Debugging log
  
      if (Array.isArray(data)) {
        setcategory(data); // Ensure `data` is an array before setting state
      } else {
        console.error("Invalid category data format:", data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  
  // Call getCategory in useEffect
  useEffect(() => {
    getCategory();
  }, []);
  
  

  const handleDelete = () => {
    if (selectedRows.length === 0) {
      setDeleteMsg("Please select category before deleting.");
      setIsConfirmationOpen(true);
      return;
    }
    setDeleteMsg("Are you sure you want to delete the selected category?");
    setIsConfirmationOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/category/deleteCategory",
        { categoryIds: selectedRows }, // Correct placement of data
        { withCredentials: true } // Correct axios config placement
      );
  
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return;
      }
  
      setRows(rows.filter((row) => !selectedRows.includes(row.category_id)));
      setSelectedRows([]);
      setIsConfirmationOpen(false);
      getCategory();
  
      setSnackbarMessage("Categories deleted successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error deleting categories:", error);
  
      if (error.response && error.response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
  
      setSnackbarMessage("Cannot delete category. Category data is associated with one or more sections.");
      setSelectedRows([]);
      setIsConfirmationOpen(false);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  
  const cancelDelete = () => {
     resetSelectedRows();
    setIsConfirmationOpen(false);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = paginatedRows.map((cat) => cat.category_id);
      setSelectedRows(newSelecteds);
      console.log("Selected all rows:", newSelecteds);
    } else {
      setSelectedRows([]);
      console.log("Deselected all rows");
    }
  };

  const handleCheckboxClick = (event, category_id) => {
    const selectedIndex = selectedRows.indexOf(category_id);
    let newSelected = [...selectedRows];

    if (selectedIndex === -1) {
      newSelected.push(category_id); 
    } else {
      newSelected.splice(selectedIndex, 1); 
    }

    setSelectedRows(newSelected);
    console.log("Updated selected rows:", newSelected);
  };

  const resetSelectedRows = () => {
    setSelectedRows([]);
    console.log("Checkboxes refreshed");
  };

  const handleModelClose = () => {
    resetSelectedRows();
    setIsUserFormOpen(false);
    setSelectedUser(null);
  };

  const handleClose = () => {
    resetSelectedRows();
    setDialogOpen(false);
    setisAddCategoryModal(false);
    setCategoryName("");
    setCategoryLabel("Enter Category");
    setCategoryId(0);
    setCategoryNameError(false);
  };
  const handleSnackbarClose = () => {
    resetSelectedRows();
    setSnackbarOpen(false);
  };
 
  const saveCategory = async () => {
    if (!categoryName.trim()) { 
      setCategoryNameError(true);
      setCategoryLabel("* Category Required");
      return;
    }
  
    try {
      const newCategory = { category_name: categoryName };
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/category/saveCategory",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // Ensure cookies are sent for authentication
          body: JSON.stringify(newCategory),
        }
      );
  
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return;
      }
  
      if (response.ok) {
        setSnackbarMessage("Category saved successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setOrder("desc");
        resetSelectedRows();
        handleClose();
        getCategory();
      } else if (response.status === 409) {
        setSnackbarMessage("Category already exists.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage("Failed to save category!");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error saving category:", error);
      setSnackbarMessage("An error occurred while saving the category.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  
  const editCategory = async () => {
    if (!categoryName.trim()) {
      setCategoryNameError(true);
      setCategoryLabel("* Category Required");
      return;
    }
  
    const sanitizedCategoryName = categoryName.trim().replace(/\s+/g, " ");
  
    try {
      const updatedCategory = { category_id: categoryId, category_name: sanitizedCategoryName };
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/category/editCategory`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // Ensure authentication cookies are sent
          body: JSON.stringify(updatedCategory),
        }
      );
  
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return;
      }
  
      if (response.ok) {
        setSnackbarMessage("Category updated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setisAddCategoryModal(false);
        getCategory();
      } else if (response.status === 409) {
        setSnackbarMessage("Category already exists.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage("Failed to update category!");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error editing category:", error);
      setSnackbarMessage("An error occurred while updating the category.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  
  useEffect(() => {
    getCategory();
  }, []);
  

  const handleChangePage = (event, newPage) => {
    resetSelectedRows();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    resetSelectedRows();
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    resetSelectedRows();
    setSearchQuery(event.target.value);
    setPage(0); 
  };

  const handleSortRequest = (property) => {
    resetSelectedRows();
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
 

  const filteredRows = category.filter((row) => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean); 
  
    return searchTerms.every((term) =>
      (row.category_name && row.category_name.toLowerCase().includes(term)) ||
      (row.category_id && String(row.category_id).toLowerCase().includes(term)) || 
      (row.total_quantity && row.total_quantity.toString().toLowerCase().includes(term)) 
    );
  });
  
  const sortedRows = filteredRows.sort((a, b) => {
    if (orderBy === "category_id" || orderBy === "total_quantity") {
      return (order === "asc" ? 1 : -1) * (a[orderBy] - b[orderBy]);

    } else if (orderBy === "category_name") {
      return (order === "asc" ? 1 : -1) * a[orderBy].localeCompare(b[orderBy]);
   
    } else {
      return 0;
    }
  });

  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  return (
    <>
      <Layout />
      <h1 className="title">Category</h1>
      <Dialog onClose={handleClose}open={isAddCategoryModal} maxWidth="xs"fullWidth={false} 
     sx={{
       '& .MuiDialog-paper': {
        width: '320px',          
        height: 'auto', 
        padding: '16px', 
        overflow: 'hidden', 
        },}}>

      <DialogTitle sx={{ position: 'relative', padding: '8px' }}>
      <span style={{ display: 'flex', alignItems: 'flex-start', color: '#0A64A2', fontSize: '1.2em' }}>
      <span style={{ display: 'inline-block', borderBottom: '2.4px solid #0A64A2', lineHeight: '1.8', width:'40em',}}>

          <img src={CategoryIcon} alt="category Image" 
          style={{
          marginRight: '0.2px', 
          height: '28px',
          width:'13%',
          color: '#0A64A2',
          right:'3px',
          // right:'5%',
          position: 'relative',
          top: '0.2em',
           }} />


            <span style={{ 
            color: '#0A64A2', 
            fontSize: '1em', 
            position: 'relative',
            left:'0.2em',
            top: '0.0em'
        }}>
          {categoryId ? 'Edit Category' : 'Add Category'}
        </span>
        </span>
        </span>

    <IconButton
      aria-label="close"
      onClick={handleClose}
      size="small"
      sx={{
        position: 'absolute',
        left: '92%',
        bottom: '68%',
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px' }}>
    <TextField
      id="outlined-basic"
      error={categoryNameError}
      value={categoryName}
      onChange={(event) => setCategoryName(event.target.value)}
      size="small"
      label={categoryLabel}
      variant="outlined"
      sx={{ marginBottom: '8px', width: '100%',top:'9px', }} 
    />

      <Button
        sx={{
          width: '75px',
          height: '36px', 
          left: '98px',  
          top: '8px',
          backgroundColor: '#0A64A2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#0A64A2',
          },
        }}
        variant="contained"
        onClick={categoryId ? editCategory : saveCategory} // Make sure categoryId is reset correctly
      >
        {categoryId ? 'Update' : 'Save'}
      </Button>

      </DialogContent>
      </Dialog>
      <Container>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
          <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              placeholder="Search..."
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              style={{ marginBottom: "0.3rem", border: "none"}}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          
         
          
          <div style={{ display: "flex" }}>
          <Button sx={{width:'50%',right:'1%'  }} variant="contained"  className="blue-btn" onClick={handleDelete}>
            Delete
          </Button>
          
            <Button
              className="blue-btn"
              onClick={openAddCategoryModal}
            >
              Add Category
            </Button>
          </div>
           {/* Confirmation Modal */}
        <Modal open={isConfirmationOpen} onClose={cancelDelete}>
          <Box sx={ModalStyle}>
            <Typography sx={{ fontSize: "1.1em", color: "#0A64A2" }}>
              {deleteMsg}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
              {selectedRows.length === 0 ? (
              ""
            ) : (
              <Button
                variant="contained"
                onClick={confirmDelete}
                className="no-btn"
              >
                Yes
              </Button>
            )}
            <Button
              variant="contained"
              onClick={cancelDelete}
              className="no-btn"
            >
              {deleteMsg === "Please select category before deleting." ? "Ok" : "No"}
            </Button>
          </Box>
        </Box>
      </Modal>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <TableContainer component={Paper}>
          <div style={{ maxHeight: "", overflow: "hidden" }}>
            <Table>
              <TableHead
                style={{
                  height: "60px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                }}
              >
                <TableRow
                  style={{
                    cursor: "pointer",
                    height: "20px",
                    position: "sticky",
                  }}
                >
                  <StyledTableCell padding="checkbox" 
                  sx={{ width: "5%", textAlign:'center' }}
                  >
                   <Checkbox
                      color="primary"
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < paginatedRows.length
                      }
                      checked={
                        paginatedRows.length > 0 &&
                        selectedRows.length === paginatedRows.length
                      }
                      onChange={handleSelectAllClick}
                      inputProps={{
                        "aria-label": "select all categories",
                      }}nputProps={{ "aria-label": "select all categories" }}
                   />

                  </StyledTableCell>
                  {[
                    { id: "category_id", label: "Category Id" },
                    { id: "category_name", label: "Category Name" },
                    { id: "total_quantity", label: "No.of Product" },
                    
                  ].map((column) => (
                    
                    <StyledTableCell
                      key={column.id} 
                      align="center"
                      onClick={() => handleSortRequest(column.id)}
                      sx={{
                        
                        // width: "40%", 
                        padding: "20px", 
                        position:'static',
                        height: "60px", 
                        "& .MuiTableSortLabel-root": {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "105%",
                          height: "100%", 
                          boxSizing: "border-box", 
                        },
                        "& .MuiTableSortLabel-icon": {
                          marginLeft: "1px", 
                          position: "relative",
                          top: "2px", 
                          
                        
                        },
                        "&:hover .MuiTableSortLabel-root": {
                          color: "black", 
                          position: "sticky",
                          
                        },
                        "& .Mui-active": {
                          color: "white",
                          position: "sticky",
                          
                        },
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                      >
                        {column.label}
                      </TableSortLabel>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
              {/* {category.map((cat) => ( */}
              {paginatedRows.map((cat) => (
                  <TableRow
                    key={cat.category_id}
                    hover
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: (theme) =>
                          alpha(theme.palette.primary.light, 0.25),
                      },
                    }}
                  >
                     <StyledTableCell padding="checkbox" style={{textAlign:'center'}}>
                     <Checkbox
                      color="primary"
                      checked={selectedRows.includes(cat.category_id)}
                      onChange={(event) => handleCheckboxClick(event, cat.category_id)}
                      inputProps={{
                        "aria-label": `select category ${cat.category_id}`,
                      }}
                    />
                    </StyledTableCell>
                    
                    <StyledTableCell
                      onClick={() => openEditCategoryModal(cat.category_id)} 
                      align="center"
                      component="th"
                      scope="row"
                    >
                      {cat.category_id} 
                    </StyledTableCell>

                    <StyledTableCell 
                      onClick={() => openEditCategoryModal(cat.category_id)}
                      align="center"
                      component="th"
                      scope="row"
                      sx={{right:'300%',}}
                    >
                      {cat.category_name} 
                    </StyledTableCell>

                    <StyledTableCell
                    onClick={() => openEditCategoryModal(cat.category_id)}
                      align="center"
                      component="th"
                      scope="row"
                     
                    >
                      {cat.total_quantity || 0} 
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>

            </Table>
          </div>

          <TablePagination
          style={{ background: "#0A64A2", color: "#fff" }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredRows.length} // Use the count of filtered rows
          rowsPerPage={rowsPerPage} 
          page={page} 
          onPageChange={handleChangePage} 
          onRowsPerPageChange={handleChangeRowsPerPage}
          handleModelClose={handleModelClose}
        />

        </TableContainer>
      </Container>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
         
          severity={snackbarSeverity}
          sx={{ alignItems: "center", width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>

        
      </Snackbar>
    </>
  );
} 













































































